import { useEffect, useContext } from 'react';
import { StoreContext } from './StoreProvider';

const PostMessageHandler = ({children}) => {
    const { setCustomerData, setSettings, player } = useContext(StoreContext);

    useEffect(() => {
        if (!player) {
            return;
        }
        window.parent.postMessage({ event: 'VIDEO_READY' }, '*');
    }, [player])

    useEffect(() => {
        window.addEventListener('message', onPostMessage);
        window.parent.postMessage({ event: 'CHILD_READY' }, '*');

        return () => {
            window.removeEventListener('message', onPostMessage);
        }
    }, []);

    const onPostMessage = (e) => {
        switch (e.data.event) {
            case 'TOGGLE_FULLSCREEN':
                break;
            case 'PARENT_READY':
                const { settings, customerData } = e.data;
                setSettings({
                    ...settings,
                    viewerId: Math.random().toString(36).substr(2, 6),
                });
                setCustomerData(customerData);
                break;
            default:
                console.error(`${e.data.event} is unknown. - App.js`);
        }
    }

    return children;
}

export default PostMessageHandler;
